import { buildColumns } from './columns';
import { components, rowClassName, onRow } from './tableComponents';
import type { ReadingTasksTableConfigOptions, ReadingTaskRow } from './types';
import type { TableProps } from 'antd/es/table';

export function createReadingTasksTableConfig(
  opts?: ReadingTasksTableConfigOptions
) {
  const columns = buildColumns(opts);
  return {
    columns,
    components,
    rowClassName,
    onRow,
  } as {
    columns: ReturnType<typeof buildColumns>;
    components: TableProps<ReadingTaskRow>['components'];
    rowClassName: (row: ReadingTaskRow) => string;
    onRow: NonNullable<TableProps<ReadingTaskRow>['onRow']>;
  };
}
